import { RouterModule, Routes } from '@angular/router';
import { UserManagementComponent } from './user-management/user-management.component';
const routes: Routes = [
  {
    path: '',
    component: UserManagementComponent,
  },
];

export const UserRoutes = RouterModule.forChild(routes);
